import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars as icon } from '@fortawesome/free-solid-svg-icons';
import LoginModal from '../../components/Modal';
import Login from '../../views/Login';
import { useUserContext } from '../../hooks/userHook';
import { userAccess } from '../../utils/user';
import { getStatus } from '../../data/api';
import version from '../../version.json';
import './SettingsMenu.scss';

type StatusType = {
  version: string,
  [x: string]: any
} | null

export default function SettingsMenu() {
  const { user, logoutUser, loginAuth0 } = useUserContext();
  const [status, setStatus] = useState<StatusType>(null);
  const access = userAccess(user);
  const navigate = useNavigate();
  const modalRef = useRef<any>(null);

  useEffect(() => {
    (async () => {
      setStatus(await getStatus());
    })();
  }, []);

  return (
    <div id="schedule-settings-menu">
      <DropdownButton
        as={ButtonGroup}
        drop="down"
        variant="outline-light"
        title={<FontAwesomeIcon icon={icon} />}
        className="dropdown-toggle"
      >
        {access.instructor && <Dropdown.Item onClick={() => navigate('/create')}>Create</Dropdown.Item>}
        <Dropdown.Item style={{
          backgroundColor: "rgba(256, 256, 256, 1)",
        }} onClick={() => navigate('/book')}>Booking</Dropdown.Item>

        <Dropdown.Divider />
        {
          user
            ? (
              <>
                <Dropdown.ItemText><small>Welcome, </small>{user.nickname}</Dropdown.ItemText>
                <Dropdown.Item onClick={() => logoutUser()}>Logout</Dropdown.Item>
                <Dropdown.Divider />
              </>
            )
            : (
              <>
                <Dropdown.Item onClick={() => loginAuth0()}>Login (Auth0)</Dropdown.Item>
                <Dropdown.Divider />
              </>
            )
        }
        <Dropdown.ItemText className="text-center">
          <small style={{ letterSpacing: 2, fontWeight: 500 }}>
            {version.version}
          </small>
          {
            status && (
              <small style={{ letterSpacing: 2, fontWeight: 300, fontSize: '75%' }}>
                &nbsp; &nbsp;
                {status.version}
              </small>
            )
          }
        </Dropdown.ItemText>
        {access.administrator && (
          <>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => navigate('/fix')} className="fullimpact-red text-small">Cleanup</Dropdown.Item>
          </>
        )}
      </DropdownButton>
      <LoginModal
        ref={modalRef}
        id="schedule-login-modal"
        header="Login"
        body={<Login onSuccessCallback={() => modalRef?.current?.show(false)} />}
        centered
      />
    </div >
  );
}